/**
 * 指挥系统口令：仅做服务端校验，前端不保存/不展示明文
 */
import apiFetch from './apiFetch';

/**
 * 向后端校验指挥访问密码
 * @param {string} password
 * @returns {Promise<{ ok: boolean, error?: string }>}
 */
export async function verifyCommandPassword(password, { timeoutMs = 15000 } = {}) {
  const input = String(password || '').trim();
  if (!input) {
    return { ok: false, error: '请输入密码' };
  }
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const timer = controller
    ? setTimeout(() => controller.abort(), timeoutMs)
    : null;
  try {
    const res = await apiFetch('/api/admin/verify-command-password', {
      method: 'POST',
      body: JSON.stringify({ password: input }),
      signal: controller?.signal
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
      return { ok: false, error: data.error || data.message || '密码错误，请重试' };
    }
    return { ok: true };
  } catch (error) {
    if (error?.name === 'AbortError') {
      return { ok: false, error: '验证超时，请检查网络后重试' };
    }
    return { ok: false, error: error.message || '验证失败' };
  } finally {
    if (timer) clearTimeout(timer);
  }
}

/**
 * 查询指挥口令是否已配置（不返回明文）
 */
export async function isCommandPasswordConfigured() {
  try {
    const res = await apiFetch('/api/admin/command-password');
    const data = await res.json();
    return !!(data.success && data.configured);
  } catch (_) {
    return false;
  }
}

/**
 * 校验指挥口令并通过后写入本地授权标记
 */
export async function authenticateCommandAccess(password, storage = typeof localStorage !== 'undefined' ? localStorage : null) {
  const result = await verifyCommandPassword(password);
  if (!result.ok) return result;
  try {
    storage?.setItem('command_authed', '1');
  } catch (_) {
    /* ignore */
  }
  return { ok: true };
}
